import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store-root'
import './assets/css/reset.css'
import './assets/scss/icon/_sprite.scss'
import './assets/js/formarDate.js'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'video.js/dist/video-js.css'
import Alert from './components/alert/alert.js'
import echarts from 'echarts'
import '../public/iconfont/iconfont.js'
import moment from 'moment'

// 通过使用一个空的Vue实例作为中央事件总线 非父子间通信
let bus = new Vue()
Vue.prototype.bus = bus
Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
Vue.prototype.$Alert = Alert
Vue.prototype.$Moment = moment
Vue.use(ElementUI)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
